var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 160,
    viewBox: "0 0 220 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M220 124C219.371 126.37 218.419 128.643 217.171 130.754C209.948 143.379 195.815 150.673 181.578 153.64C167.34 156.608 152.649 155.97 138.116 156.642C118.509 157.542 98.9479 160.852 79.3339 159.794C70.0363 159.275 60.8187 157.78 51.8331 155.333C45.8122 153.689 33.3694 151.547 29.7276 145.953C27.4496 142.467 27.0749 135.935 27 130.435C28.3638 130.648 29.7126 130.971 30.9041 131.084C34.9355 131.459 39.0157 131.5 43.0584 131.624C51.6183 131.902 60.1845 132.085 68.757 132.176C102.879 132.538 136.974 131.413 171.042 128.799C187.392 127.538 203.712 125.939 220 124Z",
    fill: "#68E1FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80,
    r: 80,
    fill: "#B9E6FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20,
    r: 8,
    fill: "#E0F2FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 126,
    r: 6,
    fill: "#E0F2FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 138,
    r: 10,
    fill: "#E0F2FE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46,
    r: 10,
    fill: "#E0F2FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11,
    r: 7,
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M87.9972 36.7869C83.3116 37.598 78.5998 38.5549 74.2744 40.5246C71.0369 41.9936 68.0845 44.0045 65.1696 46.0378C56.3837 52.1714 47.399 59.2095 43.7113 69.249C42.1637 73.4721 41.6553 78.0034 42.2288 82.4627C42.8022 86.922 44.4407 91.1792 47.0068 94.8772C49.5729 98.5751 52.9918 101.606 56.9765 103.715C60.9613 105.825 65.3957 106.951 69.9077 107C67.2214 104.827 65.0153 102.124 63.428 99.0614C61.8407 95.9982 60.9066 92.6411 60.6842 89.2009C60.4619 85.7608 60.9563 82.312 62.1362 79.0714C63.3161 75.8307 65.1561 72.8683 67.5405 70.3703C70.3616 67.4138 73.873 65.1861 77.5531 63.3958C89.3177 57.677 102.782 56.3389 115.863 56.851C128.944 57.3631 133.945 54.2795 147 55.3559C144.085 48.1272 148.474 46.4863 144.329 39.878C138.237 30.1599 131.664 31.7971 121.269 32.7016C110.134 33.707 99.0077 34.8807 87.9972 36.7869Z",
    fill: "#68E1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7397 34.7727C81.0796 35.5839 76.3934 36.5409 72.0915 38.511C68.8753 39.9801 65.9352 41.9913 63.0399 44.0249C54.3018 50.1632 45.3659 57.2024 41.702 67.2434C40.163 71.4668 39.6573 75.9984 40.2274 80.4581C40.7975 84.9178 42.4268 89.1754 44.9785 92.8738C47.5302 96.5723 50.93 99.6036 54.8926 101.714C58.8553 103.823 63.2651 104.95 67.7523 105C65.0833 102.827 62.8916 100.125 61.3147 97.0628C59.7379 94.0007 58.8099 90.6451 58.5892 87.2065C58.3685 83.768 58.8597 80.3209 60.0321 77.0817C61.2044 73.8425 63.0326 70.8811 65.4017 68.3836C68.2037 65.4266 71.696 63.1986 75.3562 61.4079C87.0605 55.6884 100.451 54.35 113.461 54.8622C126.472 55.3743 134.027 56.7837 147 57.8528C144.101 50.623 145.881 44.4885 141.777 37.8792C135.717 28.1597 129.184 29.797 118.845 30.7017C107.757 31.6923 96.6941 32.8662 85.7397 34.7727Z",
    fill: "url(#paint0_linear_529_89023)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106H75V137H80V106Z",
    fill: "#68E1FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106H75V137H80V106Z",
    fill: "url(#paint1_linear_529_89023)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92 95.5073V108H57V95.5073C57.0005 94.6519 57.1694 93.8051 57.4971 93.0151C57.8248 92.225 58.3048 91.5074 58.9098 90.9031C59.5148 90.2988 60.2328 89.8197 61.0229 89.4931C61.813 89.1666 62.6596 88.999 63.5144 89H85.4893C87.2148 89 88.8696 89.6853 90.0904 90.9055C91.3112 92.1256 91.998 93.7808 92 95.5073Z",
    fill: "#68E1FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 91C64.2223 91 64.9375 91.1388 65.6048 91.4085C66.2721 91.6782 66.8784 92.0734 67.3891 92.5717C67.8998 93.07 68.3049 93.6616 68.5813 94.3126C68.8577 94.9637 69 95.6615 69 96.3662V108H58V96.3733C57.999 95.668 58.1406 94.9695 58.4166 94.3176C58.6925 93.6657 59.0975 93.0733 59.6083 92.5742C60.1191 92.0752 60.7258 91.6793 61.3935 91.4092C62.0613 91.139 62.7771 91 63.5 91Z",
    fill: "url(#paint2_linear_529_89023)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92 95.5086V108H70.1421V94.7762C69.488 91.321 67.0234 89.7324 65 89H85.3974C87.1468 88.999 88.8251 89.684 90.0632 90.9045C91.3013 92.125 91.998 93.7811 92 95.5086Z",
    fill: "url(#paint3_linear_529_89023)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1277 107H46.8723C46.3905 107 46 107.224 46 107.5C46 107.776 46.3905 108 46.8723 108H69.1277C69.6095 108 70 107.776 70 107.5C70 107.224 69.6095 107 69.1277 107Z",
    fill: "#68E1FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1277 107H46.8723C46.3905 107 46 107.224 46 107.5C46 107.776 46.3905 108 46.8723 108H69.1277C69.6095 108 70 107.776 70 107.5C70 107.224 69.6095 107 69.1277 107Z",
    fill: "url(#paint4_linear_529_89023)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M64.086 134.305C61.1102 134.818 58.1607 135.48 55.1549 135.752C53.2036 135.933 51.0496 136.027 49.6349 137.336C49.2983 137.615 49.0749 138 49.0045 138.422C48.9257 139.326 49.9051 139.959 50.7832 140.292C53.3462 141.269 56.1268 141.548 58.8775 141.718C63.3505 141.989 67.8386 141.996 72.3266 142H85.6857C89.6334 142 94.0089 141.844 96.8346 139.192C97.4313 138.695 97.836 138.018 97.9829 137.271C98.1405 136.063 97.1873 134.923 96.0353 134.417C94.0427 133.541 91.0594 133.722 88.9054 133.491C86.066 133.208 83.2253 133.047 80.3834 133.006C74.9207 132.944 69.464 133.379 64.086 134.305Z",
    fill: "#68E1FD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4937 97.6259C82.4455 97.7899 82.3045 98.2817 82.2637 98.4609L81.7927 100.257C81.7697 100.336 81.7585 100.418 81.7594 100.501C81.7568 100.529 81.7605 100.557 81.7702 100.584C81.7799 100.61 81.7954 100.634 81.8154 100.654C81.8354 100.673 81.8595 100.688 81.8857 100.696C81.912 100.705 81.9398 100.707 81.967 100.703C82.1486 100.687 82.321 100.614 82.4603 100.493C82.6677 100.301 82.8322 100.066 82.9423 99.8026C83.0525 99.5392 83.1057 99.2545 83.0982 98.968C83.1069 98.6203 83.0282 98.2762 82.8697 97.969C82.7112 97.6617 82.4782 97.4017 82.1933 97.2142C81.7607 96.9756 81.2746 96.8585 80.784 96.8749C79.1225 96.8749 77.958 98.0186 77.958 99.6085C77.958 101.198 79.0075 102.163 80.5948 102.163C81.0029 102.163 81.4088 102.102 81.8002 101.984C82.1124 101.885 82.4095 101.741 82.6828 101.557L83.1612 102.27C82.8563 102.472 82.5255 102.63 82.1784 102.739C81.6374 102.908 81.075 102.994 80.5095 102.994C80.0362 103.022 79.5621 102.951 79.116 102.786C78.6699 102.621 78.2608 102.365 77.9135 102.033C77.6146 101.716 77.3799 101.341 77.2233 100.93C77.0667 100.519 76.9912 100.08 77.0011 99.639C76.9894 99.1737 77.0683 98.7107 77.2333 98.2772C77.3982 97.8437 77.6459 97.4486 77.9617 97.1151C78.3447 96.7359 78.7995 96.4418 79.2978 96.251C79.7961 96.0601 80.3272 95.9766 80.8582 96.0056C82.694 96.0056 83.9994 97.218 83.9994 98.9108C84.0069 99.2697 83.9452 99.6267 83.8179 99.9611C83.6906 100.295 83.5002 100.601 83.2577 100.859C83.0654 101.065 82.8352 101.23 82.5806 101.343C82.326 101.457 82.0519 101.518 81.7742 101.522C81.645 101.531 81.5156 101.507 81.3977 101.452C81.2798 101.397 81.1773 101.312 81.0992 101.206C81.0556 101.131 81.0314 101.046 81.0288 100.958C80.9039 101.122 80.743 101.254 80.5594 101.342C80.3757 101.43 80.1744 101.472 79.9718 101.465C79.193 101.465 78.6997 100.867 78.6997 99.9402C78.6997 98.5753 79.5713 97.4429 80.6171 97.4429C80.7904 97.4196 80.9666 97.4504 81.1226 97.5313C81.2787 97.6122 81.4075 97.7395 81.4923 97.8966L81.5702 97.6107L82.4937 97.6259ZM80.873 100.032C81.0619 99.6436 81.1681 99.2186 81.1845 98.785C81.1845 98.4533 81.0065 98.2245 80.7284 98.2245C80.5598 98.2387 80.3984 98.3008 80.2622 98.4038C80.126 98.5068 80.0203 98.6467 79.957 98.8078C79.7644 99.1824 79.6567 99.5968 79.6417 100.02C79.6417 100.451 79.8012 100.676 80.1016 100.676C80.402 100.676 80.6653 100.443 80.873 100.032Z",
    fill: "#68E1FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196 41L147.427 58L140 41.7856L196 41Z",
    fill: "#68E1FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196 41L147.427 58L140 41.7856L196 41Z",
    fill: "url(#paint5_linear_529_89023)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.475 48L184.781 44.8866L196 41L140 41.86L142.475 48Z",
    fill: "url(#paint6_linear_529_89023)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130 24L199 42L138.978 34.6301L130 24Z",
    fill: "#68E1FD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45L139.134 35L199 42.0271L99 45Z",
    fill: "#68E1FD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130 24L199 42L138.978 34.6301L130 24Z",
    fill: "url(#paint7_linear_529_89023)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.415 50.9901L95.9492 50.5481L95.6768 59.4646L110.143 59.9066L110.415 50.9901Z",
    fill: "#68E1FD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.447 60L96 59.5757L96.2689 51L111 51.32L110.447 60Z",
    fill: "url(#paint8_linear_529_89023)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96 51L102.782 58L110 51.5313L96 51Z",
    fill: "url(#paint9_linear_529_89023)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4362 44.4178L71.3799 38.1735L67.531 46.2211L80.5874 52.4655L84.4362 44.4178Z",
    fill: "#68E1FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8996 52L68 45.8807L71.8049 38L85 44.1339L80.8996 52Z",
    fill: "url(#paint10_linear_529_89023)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38L74.3571 48L84 44.5291L71 38Z",
    fill: "url(#paint11_linear_529_89023)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1781 64.8315L55.1963 67.9382L57.1114 73.475L66.0932 70.3683L64.1781 64.8315Z",
    fill: "#68E1FD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66 70.1674L56.9321 73L55 67.9519L64.2151 65L66 70.1674Z",
    fill: "url(#paint12_linear_529_89023)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55 68.0111L61.057 71L64 65L55 68.0111Z",
    fill: "url(#paint13_linear_529_89023)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6698 58.9393L40.8965 61.9739L42.7664 67.3799L51.5397 64.3453L49.6698 58.9393Z",
    fill: "#68E1FD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64.1693L42.9325 67L41 61.9529L50.2143 59L52 64.1693Z",
    fill: "url(#paint14_linear_529_89023)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62.0095L47.0584 65L50 59L41 62.0095Z",
    fill: "url(#paint15_linear_529_89023)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0961 84.5775L45.2939 82.3673L43.9318 86.5596L50.734 88.7697L52.0961 84.5775Z",
    fill: "#68E1FD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5461 89L44 86.5876L45.3135 82L52 84.4042L50.5461 89Z",
    fill: "url(#paint16_linear_529_89023)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82L47.35 87L52 84.4939L45 82Z",
    fill: "url(#paint17_linear_529_89023)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.999 25.5444L100.964 30.2778L103.881 37.6958L115.916 32.9623L112.999 25.5444Z",
    fill: "#68E1FD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116 33.0127L103.929 38L101 30.1842L113.266 25L116 33.0127Z",
    fill: "url(#paint18_linear_529_89023)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30.4223L109.363 34L113 26L101 30.4223Z",
    fill: "url(#paint19_linear_529_89023)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.756 25.7459L147.136 24.2089L146.188 33.8383L161.808 35.3753L162.756 25.7459Z",
    fill: "#68E1FD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M161.735 35L146 33.4864L146.956 24L163 25.4215L161.735 35Z",
    fill: "url(#paint20_linear_529_89023)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M147 24L154.206 33L163 25.7398L147 24Z",
    fill: "url(#paint21_linear_529_89023)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45L139.134 35L199 42.0271L99 45Z",
    fill: "url(#paint22_linear_529_89023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_529_89023",
    x1: 97.9664,
    y1: 91.3366,
    x2: 80.1179,
    y2: 0.860871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_529_89023",
    x1: 77.6304,
    y1: 132.946,
    x2: 77.2519,
    y2: 99.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_529_89023",
    x1: 57.9927,
    y1: 99.5036,
    x2: 69.0073,
    y2: 99.5036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_529_89023",
    x1: 79.0838,
    y1: 88.7183,
    x2: 77.0624,
    y2: 123.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_529_89023",
    x1: 57.8759,
    y1: 106.3,
    x2: 57.958,
    y2: 108.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_529_89023",
    x1: 165.772,
    y1: 56.6705,
    x2: 171.342,
    y2: 19.3886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_529_89023",
    x1: 167.63,
    y1: 47.2144,
    x2: 170.646,
    y2: 8.62343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_529_89023",
    x1: 166.084,
    y1: 20.7091,
    x2: 161.994,
    y2: 50.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_529_89023",
    x1: 107.178,
    y1: 30.9072,
    x2: 102.803,
    y2: 61.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_529_89023",
    x1: -274.326,
    y1: -386.329,
    x2: -255.774,
    y2: -362.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_529_89023",
    x1: 90.0135,
    y1: 23.6075,
    x2: 73.379,
    y2: 50.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_529_89023",
    x1: -88.3767,
    y1: -563.835,
    x2: -79.3534,
    y2: -532.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_529_89023",
    x1: 56.8403,
    y1: 53.9261,
    x2: 60.5548,
    y2: 72.7372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_529_89023",
    x1: -289.653,
    y1: -131.611,
    x2: -271.572,
    y2: -121.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_529_89023",
    x1: 42.8413,
    y1: 47.9314,
    x2: 46.5515,
    y2: 66.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_529_89023",
    x1: -303.699,
    y1: -137.493,
    x2: -285.622,
    y2: -127.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_529_89023",
    x1: 53.0856,
    y1: 72.822,
    x2: 45.2857,
    y2: 87.7114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_529_89023",
    x1: -74.9397,
    y1: -221.876,
    x2: -67.8487,
    y2: -206.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_529_89023",
    x1: 102.614,
    y1: 8.04025,
    x2: 110.573,
    y2: 36.8838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_529_89023",
    x1: -376.279,
    y1: -211.615,
    x2: -351.617,
    y2: -198.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_529_89023",
    x1: 160.399,
    y1: 2.53597,
    x2: 153.242,
    y2: 35.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_529_89023",
    x1: -241.99,
    y1: -534.15,
    x2: -221.122,
    y2: -505.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_529_89023",
    x1: 149.266,
    y1: 31.6056,
    x2: 148.589,
    y2: 62.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIllustration);
export default __webpack_public_path__ + "static/media/message-illustration.e25aa08b6ea97a33565a520b4fce7112.svg";
export { ForwardRef as ReactComponent };